import { render, staticRenderFns } from "./SwiperCarrousel.vue?vue&type=template&id=e62f74fc&scoped=true&"
import script from "./SwiperCarrousel.vue?vue&type=script&lang=js&"
export * from "./SwiperCarrousel.vue?vue&type=script&lang=js&"
import style0 from "./SwiperCarrousel.vue?vue&type=style&index=0&id=e62f74fc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e62f74fc",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {SwiperCarrouselSlide: require('/codebuild/output/src3208117147/src/studio-frank/components/SwiperCarrouselSlide.vue').default})
